import { css } from 'styled-components';
import { getTypography, TypographyName } from '../../theme';
export const main = _ref => {
  let {
    theme,
    $error
  } = _ref;
  return css(["", " margin-top:0.5rem;display:block;color:", ";", ""], getTypography(theme, TypographyName.SMALL), theme.palettes.neutrals.medium, $error && `
    font-weight: 700;
    color: ${theme.palettes.status.alert};
  `);
};
//# sourceMappingURL=Help.style.js.map